import { Component } from '@angular/core';
import { LoaderService } from '../../../core/ui/loader';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-loader',
	standalone: true,
	imports: [CommonModule, MatProgressSpinnerModule],
	templateUrl: './loader.html',
  	styleUrl: './loader.css'
})

export class Loader {
	constructor(public loaderService: LoaderService) {}
}